
const StatisticData = [
    {
        img: 'https://res.cloudinary.com/devsprime/image/upload/v1625284315/statistics%20card%20assets/Group_210_yolsx2.svg',
        count:"5,679",
        label:"Registered Students",

    },
    {
        img: 'https://res.cloudinary.com/devsprime/image/upload/v1625284315/statistics%20card%20assets/Group_208_nc1kcx.svg',
        count:"2,679",
        label:"Student has been helped to achieve their dreams",

    },
    {
        img: 'https://res.cloudinary.com/devsprime/image/upload/v1625284315/statistics%20card%20assets/Group_209_g7e154.svg',
        count:"10,000",
        label:"More than 10,000 people visits our site monthly",

    },
    {
        img: 'https://res.cloudinary.com/devsprime/image/upload/v1625284315/statistics%20card%20assets/Group_207_fumxcx.svg',
        count:"#10",
        label:"Ranked among the top 10 growing online learning startups in West Africa",
    },

]

export default StatisticData;